<template>
    <div>
        <h1>Unauthorized</h1>
    </div>
</template>